<template>
  <div class="epi-intro">
    <p class="epi-intro__lead">
      Epigenetics looks at how your lifestyle and environment switch your genes on and off —
      a snapshot of your biological age and how your body is ageing right now.
    </p>
    <ul class="epi-intro__points">
      <li>See your biological age versus your actual age.</li>
      <li>Re-test over time to track how it changes.</li>
      <li>It's a separate kit from your ancestry test.</li>
    </ul>
    <div class="epi-intro__actions">
      <button class="ldna-btn" @click="$emit('explore')">Explore epigenetic kits</button>
      <button class="ldna-btn ldna-btn--secondary" @click="$emit('close')">Maybe later</button>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";
defineEmits(["close", "explore"]);
</script>

<style scoped>
.epi-intro {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 4px 8px;
}
.epi-intro__lead {
  margin: 0;
  color: #1b1b1b;
  line-height: 1.5;
}
.epi-intro__points {
  margin: 0;
  padding-left: 18px;
  color: #4b5563;
  line-height: 1.6;
}
.epi-intro__points li {
  margin-bottom: 6px;
}
.epi-intro__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}
</style>
